/**
 * Session Token Override
 *
 * Every platform request carries the signed-in session's token. Normally that
 * is the identity provider's (Clerk's) token for the current user. An
 * embedding surface — the admin impersonation frame — needs every request to
 * carry a different credential instead: a platform-minted actor token that
 * resolves as the impersonated user.
 *
 * One module owns that decision. The provider is a function rather than a
 * value because the credential is short-lived and the owner refreshes it on
 * demand; the hooks only ever ask "what token should this request carry?".
 */

export type SessionTokenProvider = () => Promise<string | null>;

let sessionTokenOverride: SessionTokenProvider | null = null;

/**
 * Route every platform request through `provider` instead of the identity
 * provider's session token. Pass `null` to restore the default. Set before the
 * React tree renders so the first request already uses it.
 */
export function setSessionTokenOverride(
  provider: SessionTokenProvider | null,
): void {
  sessionTokenOverride = provider;
}

export function getSessionTokenOverride(): SessionTokenProvider | null {
  return sessionTokenOverride;
}
